import moment, {Moment} from 'moment-timezone'

import {
  CustomTaskRepetition,
  QuickSelectRepetition,
  TaskRepetition,
  TaskRepetitionUnit,
  IsoWeekDay,
  isoWeekDays
} from '@hconnect/common/types'

export const getDefaultWeekdays = (startDate: Moment | Date): IsoWeekDay[] => {
  const momentDate = startDate instanceof Date ? moment(startDate) : startDate
  return [isoWeekDays[momentDate.clone().isoWeekday() - 1]]
}

export const quickSelectRepetition = (repetition?: TaskRepetitionUnit) => {
  const repetitionInfo: TaskRepetition = {
    repetition: repetition || 'weekly'
  }
  return repetitionInfo
}

export const fromQuickSelectToCustomTaskRepetition = (
  current: QuickSelectRepetition,
  startDate: Moment,
  defaultRepetition?: QuickSelectRepetition
): CustomTaskRepetition => {
  if (current.repetition === 'daily') {
    return {
      repeatEvery: 1,
      repetition: 'daily',
      startDate
    }
  } else if (current.repetition === 'monthly') {
    return {
      repeatEvery: 1,
      repetition: 'monthly',
      startDate
    }
  } else if (current.repetition === 'yearly') {
    return {
      repeatEvery: 1,
      repetition: 'yearly',
      startDate,
      weekDays: getDefaultWeekdays(startDate)
    }
  } else if (defaultRepetition) {
    // else default or weekly
    return fromQuickSelectToCustomTaskRepetition(defaultRepetition, startDate)
  }

  return {
    repeatEvery: 1,
    repetition: 'weekly',
    startDate,
    weekDays: getDefaultWeekdays(startDate)
  }
}

export const fromQuickSelectToCustomTaskRepetitionDailyWeekly = (
  current: QuickSelectRepetition,
  startDate: Moment
): CustomTaskRepetition => {
  if (current.repetition === 'daily') {
    return {
      repeatEvery: 1,
      repetition: 'daily',
      startDate
    }
  }
  return {
    repeatEvery: 1,
    repetition: 'weekly',
    startDate,
    weekDays: getDefaultWeekdays(startDate)
  }
}

export const changeCustomTaskRepetition = (
  next: 'daily' | 'weekly' | 'monthly' | 'yearly',
  current: CustomTaskRepetition
): CustomTaskRepetition => {
  const endingsOptions = current.endDate
    ? {endDate: current.endDate}
    : current.endsAfterRepetitions
      ? {endsAfterRepetitions: current.endsAfterRepetitions}
      : {}

  if (next === 'daily') {
    return {
      repeatEvery: current.repeatEvery,
      repetition: 'daily',
      startDate: current.startDate,
      ...endingsOptions
    }
  } else if (next === 'monthly') {
    return {
      repeatEvery: current.repeatEvery,
      repetition: 'monthly',
      startDate: current.startDate,
      ...endingsOptions
    }
  } else if (next === 'yearly') {
    return {
      repeatEvery: current.repeatEvery,
      repetition: 'yearly',
      startDate: current.startDate,
      ...endingsOptions
    }
  }
  // else weekly
  return {
    repeatEvery: current.repeatEvery,
    repetition: 'weekly',
    startDate: current.startDate,
    weekDays: getDefaultWeekdays(current.startDate),
    ...endingsOptions
  }
}
